export var SENTRY_RELEASE = "d178fc19a3ba0cec9b7452db8f7347225fb3cd14";
